import { render, staticRenderFns } from "./index.vue?vue&type=template&id=48a1c054&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=48a1c054&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a1c054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48a1c054')) {
      api.createRecord('48a1c054', component.options)
    } else {
      api.reload('48a1c054', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=48a1c054&scoped=true", function () {
      api.rerender('48a1c054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/fundManagement/fundTransactionDetails/index.vue"
export default component.exports